import type { Feature } from '@luna/gatekeeper';

export const cardDelivery: Feature = {
    enabled: false,
    _description:
        'Enables display of the card delivery change feature in the delivery settings section of the cards services list in bank card settings, supplementary card settings and credit card functions page',
};
